import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getRiskLevelDescriptions } from '@api/lookups';
import { IRiskLevelDescription } from '@interfaces/lookups';

export const handleGetRiskLevelDescriptions = createAsyncThunk<
  AxiosResponse<IRiskLevelDescription[]>,
  void
>('getRiskLevelDescriptions', getRiskLevelDescriptions);
